class JobModel {
  constructor({
    jobId = null,
    jobName = "",
    departmentId = null,
    companyId = null,
    reportingToSolidLine = "",
    reportingToDottedLine = "",
    referencedJobId = null,
    departmentName = "",
    createdAt = new Date(),
    updatedAt = new Date(),
    reportingToSolidId = null,
    reportingToDottedId = null,
    jobGroupId = null,
    contractualHours = null,
  } = {}) {
    this.jobId = jobId;
    this.jobName = jobName;
    this.departmentId = departmentId;
    this.companyId = companyId;
    this.reportingToSolidLine = reportingToSolidLine;
    this.reportingToDottedLine = reportingToDottedLine;
    this.referencedJobId = referencedJobId;
    this.departmentName = departmentName;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.reportingToDottedId = reportingToDottedId;
    this.reportingToSolidId = reportingToSolidId;
    this.jobGroupId = jobGroupId;
    this.contractualHours = contractualHours;
  }
}

export default JobModel;
